var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"HOME","name":"HOME","data-command":_vm.$t('homeButton')}},[_c('img',{attrs:{"src":"/images/icons/home.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('homeButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }